module.exports = __webpack_public_path__ + "static/media/dashboard_lg.f9f796aa.jpg";